import { render } from "./LoadingComment.vue?vue&type=template&id=f75341d0&scoped=true&ts=true"
import script from "./LoadingComment.vue?vue&type=script&lang=ts"
export * from "./LoadingComment.vue?vue&type=script&lang=ts"

import "./LoadingComment.vue?vue&type=style&index=0&id=f75341d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f75341d0"]])

export default __exports__